// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Aniversariantes_MensagemconfigGetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /aniversariantes/mensagem-config/{franquia_id}
 *
 * Returns the configured birthday message for a franchise.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Aniversariantes_MensagemconfigGetResponseDados {
franquia_id: number
mensagem_aniversariante?: string
}

export type Aniversariantes_MensagemconfigGetResponse = ApiResponse<Aniversariantes_MensagemconfigGetResponseDados>;

registerResponseContract('Aniversariantes_MensagemconfigGetResponse', {
  franquia_id:             { type: 'number',  required: true },
  mensagem_aniversariante: { type: 'string',  required: false },
})
